document.addEventListener("DOMContentLoaded",()=>{
  const drawer=document.querySelector("[data-v4-drawer]");
  const open=document.querySelector("[data-v4-open]");
  const close=document.querySelector("[data-v4-close]");
  if(open&&drawer)open.addEventListener("click",()=>{drawer.classList.add("open");document.body.style.overflow="hidden"});
  if(close&&drawer)close.addEventListener("click",()=>{drawer.classList.remove("open");document.body.style.overflow=""});

  document.addEventListener("click",async e=>{
    const btn=e.target.closest("[data-v4-quick]");
    if(!btn)return;
    e.preventDefault();
    try{
      const res=await fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:[{id:Number(btn.dataset.v4Quick),quantity:1}]})});
      if(!res.ok)throw new Error();
      const toast=document.querySelector("[data-v4-toast]");
      if(toast){toast.textContent="Added to cart";toast.classList.add("show");setTimeout(()=>toast.classList.remove("show"),1600)}
      const count=document.querySelector("[data-v4-cart-count]");
      if(count)count.textContent=Number(count.textContent||0)+1;
    }catch(err){
      const toast=document.querySelector("[data-v4-toast]");
      if(toast){toast.textContent="Unable to add this item";toast.classList.add("show");setTimeout(()=>toast.classList.remove("show"),1800)}
    }
  });
});
